import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Backend always returns 200 to avoid enumeration; only network errors fall here.
      toast.error("Could not reach the server. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grain relative flex items-center justify-center px-6">
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10">
          <div className="w-8 h-8 border border-[#00D4FF] rotate-45 flex items-center justify-center">
            <span className="-rotate-45 text-[#00D4FF] font-mono text-xs font-bold">M</span>
          </div>
          <div>
            <div className="font-display text-lg leading-none">Martingale</div>
            <div className="overline leading-none mt-1">PLAYBOOK·TERMINAL</div>
          </div>
        </Link>

        <div className="overline mb-2">RECOVER</div>
        <h1 className="font-display text-4xl mb-8">Reset your password.</h1>

        {sent ? (
          <div
            data-testid="forgot-sent"
            className="border border-[#00D4FF]/40 bg-[#00D4FF]/5 p-6 text-sm text-zinc-300 leading-relaxed"
          >
            <div className="overline neon-text mb-2">CHECK YOUR INBOX</div>
            If an account exists for <span className="mono">{email}</span>, we've sent a
            reset link. It expires in 60 minutes. Don't forget to check spam.
            <div className="mt-5">
              <Link
                to="/login"
                className="text-xs mono uppercase tracking-widest text-zinc-400 hover:text-[#00D4FF]"
              >
                ← Back to login
              </Link>
            </div>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="space-y-5 border border-zinc-800 p-8 bg-zinc-950/40"
          >
            <p className="text-sm text-zinc-400">
              Enter the email you registered with. We'll send a reset link to it.
            </p>
            <div>
              <label className="overline block mb-2">EMAIL</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
                className="w-full bg-transparent border border-zinc-800 px-3 py-3 mono text-sm focus:outline-none focus:border-[#00D4FF]"
                placeholder="you@book.com"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit"
              className="w-full py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs disabled:opacity-50 hover:brightness-110"
            >
              {loading ? "Sending..." : "Send reset link"}
            </button>
          </form>
        )}

        <div className="mt-6 text-sm text-zinc-500">
          Remembered it?{" "}
          <Link to="/login" className="text-[#00D4FF] underline">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
}
